import React from "react";
import { Box } from "@mui/material";
import { styled } from '@mui/material/styles';
import MuiAccordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const DEMO_FAQS = [
  {
    question: "What is the difference between sequencing a whole genome and an exsome?",
    answer:
      "Whole genome sequencing (WGS) provides a comprehensive analysis of an organism's entire DNA, encompassing both the coding regions (exons) and the crucial non-coding regions. In contrast, exome sequencing focuses solely on the exons, which, though containing most known disease-related genetic variants, comprise only about 1-2% of the genome. This focus means exome sequencing might miss significant genetic information present in the non-coding regions, which are analyzed in WGS. Therefore, while exome sequencing is efficient for certain applications, WGS is preferred for a more complete genetic understanding, ensuring no potentially important regions are overlooked.",
  },
  {
    question: "How often will I need to get my whole genome tested?",
    answer:
      "One of the benefits of sequencing your whole genome is that you do not need to do it after the initial sample is submitted.   Your genome doesn't change.  What changes are the actionable conditions associated with your genomic results.   As part of your annual membership fee, dDNA will rerun your sample annually, as long as you are a member, to see if any new conditions have become actionable.    This should be a discussion between you and your descendantsDNA genetic fellow during your annual physical.",
  },
  {
    question: "What is the best way to contact my descendantsDNA genetic fellow to get answers to any questions that I may have?",
    answer:
      "The Chat feature on either your portal or the app on your cellular device is the best way to contact your dDNA genetic fellow.  Click on the conversation icon and choose who you want to direct message.   They will respond to you within 24 hours.",
  },
  {
    question: "Can descendantsDNA make an referral to a specialist if my genetic report warrants one?",
    answer: 'Absolutely.   Our recommendation is that you discuss your laboratory report via the patient portal with your dDNA genetic fellow and after that if a specialty referral is needed dDNA can provide one.    One caveat is that your insurance provider may have restrictions on who is "in network" and who is "out of network".    That will dramatically impact your out of pocket expense.'
  },
  {
    question: "Can descendantsDNA make a referral to a PCP is my current PCP does not recognize or isn't trained on genetics?",
    answer: "Absolutely.   If you have purchased your LCP from one of our sales consultants we have a wide variety of dDNA genetic fellows that we would be happy to recommend to you and your family.  Again, based on your insurance providers in and out of network status, your out of pocket expenses may vary."
  },
  {
    question: "How many positive variants should I expect on my Heart Report, Oncology Report?",
    answer: "Each patient is unique, but in general, most reports have no variants.   One or two variants on either the heart report or the oncology report is very common.   Each variant should be discussed with your dDNA genetic fellow."
  },
  {
    question: "What do I get for the annual membership fee to descendantsDNA?",
    answer: "Our annual fee is what makes dDNA unique.   We supply you with updated genetic data throughout the year with specific information based on your whole genome.    Any new actionable conditions are sent to both you and your genetic fellow so that you can make informed decisions on the most up to date clinical information.    Each year your data is rerun and compared to the latest ClinVar database so that all actionable conditions are reported to both you and your dDNA genetic fellow."
  },
  {
    question: "How many different genes are tested in the whole genome sequencing I purchased with my Longevity Concierge Plan?",
    answer: "All known genetic variants are tested for when you purchase your Longevity Concierge Plan.   In general, 93 cardiovascular genes and over 100 oncology genes are tested.    In total, every genetic variant with a known disease is housed in the ClinVar database.   We use that database to monitor what genes we test."
  },
  {
    question: "Why is genetic testing becoming so popular?",
    answer: "Genetic testing has gained popularity due to its increasing accessibility, affordability, and the valuable insights it offers into personal health and ancestry. This technology enables individuals to make informed decisions about their health care and discover their genetic heritage, appealing to a wide range of personal and medical interests."
  },
  {
    question: "Are there any good websites that I can go to in order to research my variants?",
    answer: "Yes, there are several reputable websites where you can research your genetic variants. Websites like NCBI’s ClinVar, the Genome Aggregation Database (gnomAD), and the Online Mendelian Inheritance in Man (OMIM) offer extensive information on genetic variants and their potential impacts on health. These platforms provide detailed, research-supported data that can help you understand the significance of specific genetic findings. However, it's important to consult with a healthcare professional or a genetic counselor for personalized interpretation and advice regarding your genetic information."
  }
];

const SectionFaq = (props) => {
  return (
    <Box 
      sx={{
        border: '1px solid',
        borderColor: 'background.default',
        borderRadius: '24px',
        padding: '16px',
        bgcolor: 'white'
      }}
    >
      <Typography variant='h2' color="primary.black" gutterBottom>
        FAQ
      </Typography>
      <Box
        sx={{
          mt: '18px'
        }}
      >
        {DEMO_FAQS.map((item, idx) => (
          <Accordion
            key={idx}
            sx={{
              width: '100%',
              marginBottom: "16px",
              backgroundColor: "primary.lightGray",
              borderRadius: "8px",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography variant="h4" color="primary.black">{item.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body" color="primary.darkGray">{item.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: 'none',
  
  '&:not(:last-child)': {
    borderBottom: 0,
    // marginBottom: '14px',
  },
  '&:before': {
    display: 'none',
  },
}));

export default SectionFaq;
